import Nullstack from 'nullstack';
export default function IconTableShortcut({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-table-shortcut",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), "   ", Nullstack.element("path", {
    d: "M4 10h16"
  }), "   ", Nullstack.element("path", {
    d: "M10 4v8"
  }), "   ", Nullstack.element("path", {
    d: "M3 21l6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M4 15h5v5"
  }), " ");
}